import s from "~/pages/Logs/styles.less";
import React from "react";
import { useTranslation } from "react-i18next";

interface IDefaultLog {
  logInstance: any;
  filedKey: string;
}

const DefaultLog = ({ logInstance, filedKey }: IDefaultLog) => {
  const { t } = useTranslation();
  return (
    <div className={s.breakeword}>
      <b>
        {logInstance.__typename === "EmployeeLog" && filedKey === "name"
          ? t(`k.namePeople`)
          : Number.isInteger(Number(filedKey))
          ? t(`k.role`)
          : filedKey.split("_")[1] === "Files"
          ? t(`k.${filedKey.split("_")[1]}`)
          : t(`k.${filedKey}`)}
      </b>{" "}
      <span>
        {filedKey === "catalog"
          ? t(`pkd.${logInstance[filedKey]}`)
          : Number.isInteger(Number(filedKey))
          ? t(`k.${logInstance[filedKey]}`)
          : logInstance[filedKey]}
      </span>
    </div>
  );
};

export default DefaultLog;
